import { render, staticRenderFns } from "./WelcomeView.vue?vue&type=template&id=3f86d2ba"
import script from "./WelcomeView.vue?vue&type=script&lang=js"
export * from "./WelcomeView.vue?vue&type=script&lang=js"
import style0 from "./WelcomeView.vue?vue&type=style&index=0&id=3f86d2ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports